import HandoffDetailDialog from "./handoffDetailDialog.container";

export default HandoffDetailDialog;
